/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerNotification as ModelsCustomerCustomerNotification } from '../../models/Models/Customer/customer-notification';

export interface V3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Params {
  notificationId: string;
  readStatus: boolean;
}

export function v3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml(http: HttpClient, rootUrl: string, params: V3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerNotification>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml.PATH, 'patch');
  if (params) {
    rb.path('notificationId', params.notificationId, {});
    rb.path('readStatus', params.readStatus, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerNotification>;
    })
  );
}

v3CustomersMeNotificationsNotificationIdReadStatusPatch$Xml.PATH = '/v3/customers/me/notifications/{notificationId}/{readStatus}';
